import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import DatePicker from './DatePicker'
import moment from 'moment'
import DrawerFilterDate from '../../../../../Drawer'
import IcOutlineCalendarMonth from '../../../../../../assets/icons/navFilter/IcOutlineCalendarMonth'

export default function DateFilter({
  setSelectedDate,
  deliveryDateFilter,
  filterStateChanged,
  datePickedFiltersValues,
  nameFilter,
  dateFilterLabel,
}) {
  const [opentDrawer, setOpentDrawer] = useState(false)
  const [state, setState] = useState(null)
  const toggleDrawer = (open, event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return
    }
    if (!open) {
      if (state) {
        const pickedDate = moment(state).startOf('day').format('YYYY-MM-DD HH:mm')
        if (!deliveryDateFilter) {
          setSelectedDate(pickedDate)
        }
        filterStateChanged(deliveryDateFilter ? 'dropOffDay' : 'datepicked', [
          pickedDate.toString().slice(0, 10),
        ])
      } else {
        filterStateChanged(nameFilter, [])
      }
    }
    setOpentDrawer(open)
  }

  const dateForm = (date) => moment(date).format('DD MMM YYYY')

  useEffect(() => {
    if (datePickedFiltersValues && datePickedFiltersValues.length > 0) {
      const pickedDate = moment(datePickedFiltersValues[0])
        .startOf('day')
        .format('YYYY-MM-DD HH:mm')
      if (!deliveryDateFilter) {
        setSelectedDate(pickedDate)
      }
      setState(new Date(pickedDate))
    } else {
      setState(null)
    }
  }, [datePickedFiltersValues])

  const onCancel = () => {
    setState(null)
  }

  return (
    <DrawerFilterDate
      filterLabel={
        !state
          ? dateFilterLabel
          : dateFilterLabel
          ? dateFilterLabel + ' : ' + dateForm(state)
          : dateForm(state)
      }
      content={<DatePicker state={state} setState={setState} />}
      toggleDrawer={toggleDrawer}
      opentDrawer={opentDrawer}
      Icon={IcOutlineCalendarMonth}
      id={nameFilter}
      annulationDate={true}
      checkedTodayDate={false}
      onCancel={onCancel}
    />
  )
}
DateFilter.propTypes = {
  setSelectedDate: PropTypes.func,
  deliveryDateFilter: PropTypes.bool,
  dateFilterLabel: PropTypes.string,
  filterStateChanged: PropTypes.func,
  datePickedFiltersValues: PropTypes.array,
  nameFilter: PropTypes.string,
}
